import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  CircularProgress,
  Select,
  MenuItem,
} from "@material-ui/core";
import { panelUsersAuthStyle } from "../../panelUsersAuthStyle";
import { Store } from "react-notifications-component";
import { getClientes } from "../../../domain/api/ClientesApi";
import { useDispatch } from "react-redux";
import { crearUbicaciones } from "../../../domain/api/UbicacionesApi";

export const CreateUbicacion = ({ create, clearData }) => {
  const dispath = useDispatch();

  const classes = panelUsersAuthStyle();
  const [isLoading, setIsLoading] = useState(false);
  const [nombre, setNombre] = useState("");
  const [clientes, setClientes] = useState([]);
  const [asigCliente, setAsigCliente] = useState("");

  const handleAlert = (title, message, type) => {
    Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
  };

  const crearUbi = async (request) => {
    try {
      setIsLoading(true);
      const response = await crearUbicaciones(dispath, request);

      if (response) {
        handleAlert("Creado Exitosamente!", `${nombre} creado con éxito!`, "success");
        clearData();
        create("all", "", 0, 30)

      } else {
        handleAlert("Ocurrió un error!", "Ocurrió un error al cambiar el estado", "danger");
      }
    } catch (error) {
      handleAlert("Ocurrió un error!", "Error interno", "danger");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!nombre || !asigCliente) {
      handleAlert("Campos requeridos", "Por favor, complete todos los campos obligatorios.", "warning");
      return;
    }

    const request = {
      cliente: asigCliente,
      valor: nombre,
    };
    crearUbi(request);
  };

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const response = await getClientes(dispath, "", 0, 30);
        if (response && response.content) {
          setClientes(response.content);
        }
      } catch (error) {
        console.error("Error fetching clients:", error);
      }
    };

    fetchClientes();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3} style={{ textAlign: "left" }}>
        <Grid item xs={12} md={12} sm={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="nombre">Nombre</InputLabel>
            <OutlinedInput
              id="nombre"
              type="nombre"
              name="nombre"
              value={nombre}
              required
              onChange={(e) => setNombre(e.target.value)}
              startAdornment={<InputAdornment position="start">-</InputAdornment>}
              labelWidth={100}
              style={{borderRadius:'10px'}}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12} sm={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="Cliente" shrink style={{ fontWeight: "bold", fontSize: "18px" }}>
              Cliente*
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="Cliente"
              name="Cliente"
              value={asigCliente}
              style={{ fontSize: "18px",borderRadius:'10px' }}
              onChange={(e) => setAsigCliente(e.target.value)}
              label="Cliente"
              startAdornment={<InputAdornment position="start">-</InputAdornment>}
            >
              <MenuItem value="">
                <em>Selecciona un Cliente</em>
              </MenuItem>

              {clientes.map((item) => (
                <MenuItem value={item.id} key={item.id}>
                  {item.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <div className={classes.wrapper}>
        <Grid container justifyContent="center" style={{ marginTop: "10px" }}>
          <Button
            disabled={!nombre || !asigCliente || isLoading}
            type="submit"
            variant="contained"
            color="primary"
            style={{ textTransform: "none", width: "40%",borderRadius:'10px' }}
          >
            {isLoading ? "Creando..." : "Crear Ubicación"}
          </Button>
        </Grid>
      </div>
    </form>
  );
};
